import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import { Button, Container, Typography } from "@material-ui/core";

import CenteredContent from "../components/CenteredContent";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    position: "relative",
    textAlign: "center",
  },
  imageFull: {
    maxWidth: "100%",
    margin: 0,
    padding: 0,
  },
  imageTitle: {
    position: "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -40%)",
    fontWeight: "bold",
    textShadow: "black 1px 1px 6px",
    color: "white",
    padding: theme.spacing(4),
  },
  imageSubtitle: {
    position: "absolute",
    top: "55%",
    left: "50%",
    transform: "translate(-50%, -55%)",
    fontWeight: "bold",
    textShadow: "black 1px 1px 6px",
    color: "white",
    padding: theme.spacing(4),
  },
  imageButton: {
    position: "absolute",
    top: "65%",
    left: "50%",
    transform: "translate(-50%, -65%)",
    fontWeight: "bold",
    backgroundColor: "#ffc26c",
    color: "#504538",
  },
}));

const HomePage = (props) => {
  const { language } = useContext(LanguageContext);
  const classes = useStyles();

  return (
    <>
      <div className={classes.imageContainer}>
        <img
          src={`${process.env.PUBLIC_URL}/images/back.jpg`}
          className={classes.imageFull}
        />
        <Typography variant="h3" align="center" className={classes.imageTitle}>
          {localize("home.title", language)}
        </Typography>
        <Typography
          variant="h5"
          align="center"
          className={classes.imageSubtitle}
        >
          {localize("home.subtitle", language)}
        </Typography>
        <Link to={"/form"}>
          <Button variant="contained" className={classes.imageButton}>
            {localize("home.letsgo", language)}
          </Button>
        </Link>
      </div>

      <Container component="main" maxWidth="xl">
        <CenteredContent margin={1}></CenteredContent>
      </Container>
    </>
  );
};

export default HomePage;
